import
  React
from 'react';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  ColorSvg,
  Text,
  VContainerH,
  VContainerVH
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../../constants';

import {
  SecondaryButton
} from 'components';

import {
  withScreenViewTagging
} from 'hocs';

import {
  getStorageWithExpiry
} from 'helpers';

const Card = styled(VContainerH)`
  z-index: 5;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const PurchaseSummaryUI = props => {

  const offer = props.offer;

  PurchaseSummaryUI.tagViewData = {
    journey_event: 'journey_end',
    journey_name: 'cbu: connectu: just 4 you',
    journey_type: 'just for you',
    journey_step: 'cbu: connectu: just 4 you: purchase complete',
    transaction_id: props.transactionId,
    sales_event:  'transaction_complete,justforyou',
    product_id: [ offer?.description ],
    product_category: 'just 4 you',
    product_quantity: '1',
    product_price: offer?.price,
    customer_city: getStorageWithExpiry('Location', 'city', null),
    visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
    visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', ''),
    page_section: 'just 4 you',
    visitor_type: 'consumer'
  };

  if (!!props.error) {

    PurchaseSummaryUI.tagViewData = {
      page_event: 'page_error',
      error_message: props.error,
      page_section: 'just 4 you'
    };
  }

  return (

    <Card
      backgroundColor={CustomColors.White}
      borderRadius={'4px'}
      padding={'16px 50px 26px'}
      maxWidth={'350px'}
      boxSizing={'border-box'}
      width={'92%'}>

      <VContainerVH>

        <ColorSvg
          src={props.isSuccess ? Icons.CheckmarkCircle : Icons.WarningTriangle}
          color={props.isSuccess ? CustomColors.Green5 : CustomColors.Red2}
          height={'67px'}
          width={'67px'}/>

        <Text
          fontSize={'16px'}
          fontWeight={'bold'}
          color={CustomColors.Grey9}
          textAlign={'center'}
          padding={'16px 0'}>

          { !!props.error? props.error : props.isSuccess ?
            'We have received your purchase request. Vodacom will SMS you when your purchase is successful.'
            : 'There was a problem activating your bundle. Please try again later or call 082 135'
          }

        </Text>

        <SecondaryButton
          text={'Close'}
          onClick={props.onClose}/>

      </VContainerVH>
    </Card>
  );
};

PurchaseSummaryUI.propTypes = {
  isSuccess: PropTypes.bool.isRequired,
  error: PropTypes.string,
  offer: PropTypes.object,
  transactionId: PropTypes.string
};

PurchaseSummaryUI.defaultProps = {
  isSuccess: true,
  error: '',
  offer: {},
  transactionId: ''
};

PurchaseSummaryUI.pageName = 'cbu: connectu: just 4 you: purchase complete';

export const PurchaseSummary = withScreenViewTagging(PurchaseSummaryUI);